<template>
  <div class="travel">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent"
              @click="showModal(null)"
            >
              新增行程
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋編號、名稱、分類、天數"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(days)="data">
              {{ data.item.days }}
            </template>
            <template v-slot:cell(category)="data">
              {{ data.item.category.name }}
            </template>
            <template v-slot:cell(start_at)="data">
              {{ data.item.start_at ? data.item.start_at.join('、') : '' }}
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex flex-nowrap flex align-items-center">
                <div class="form-check check-icon">
                  <input
                    v-model="data.item.status"
                    class="form-check-input"
                    type="checkbox"
                    :id="'status' + data.item.id"
                    @click="toggleStatus(data.item.id)"
                  />
                  <label
                    class="form-check-label"
                    :class="{ 'text-primary': data.item.show }"
                    :for="'status' + data.item.id"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="data.item.show ? '隱藏' : '顯示'"
                  >
                    <i
                      class="bi"
                      :class="
                        data.item.show ? ' bi-eye-fill' : 'bi-eye-slash-fill'
                      "
                    ></i>
                  </label>
                </div>
                <button
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="編輯"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
                <button
                  @click="showDeleteModal(data.item.id, data.item.name)"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="刪除"
                >
                  <i class="bi bi-trash me-2"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
    <div
      class="modal fade"
      id="travelModal"
      tabindex="-1"
      ref="travelModal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-fullscreen-xl-down modal-dialog-scrollable"
      >
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isEdit ? '編輯行程：' + modalDate.name : '新增行程' }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="modalSerial_no" class="form-label required"
                      >行程編號</label
                    >
                    <input
                      v-model="modalDate.serial_no"
                      type="text"
                      class="form-control"
                      id="modalSerial_no"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalTitle" class="form-label required"
                      >行程名稱</label
                    >
                    <input
                      v-model="modalDate.name"
                      type="text"
                      class="form-control"
                      id="modalTitle"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label required">分類</label>
                    <select
                      v-model="modalDate.category_id"
                      class="form-select"
                      required
                    >
                      <option :value="null">請選擇分類</option>
                      <option
                        v-for="category in travelCategory"
                        :value="category.id"
                        :key="'travelCategory' + category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="mb-3"
                    v-if="travelCategorySub && travelCategorySub.length"
                  >
                    <label class="form-label">子分類</label>
                    <select v-model="modalDateCategorySub" class="form-select">
                      <option :value="null">請選擇子分類</option>
                      <option
                        v-for="category in travelCategorySub"
                        :value="category.id"
                        :key="'travelCategory' + category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="modalDeparture_date" class="form-label"
                      >出發日期</label
                    >
                    <vcalendar
                      v-model="modalDate.start_at"
                      id="modalDeparture_date"
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalDays" class="form-label required"
                      >行程天數</label
                    >
                    <input
                      v-model.number="modalDate.days"
                      type="number"
                      class="form-control"
                      id="modalDays"
                      min="1"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalPrice" class="form-label required"
                      >價格</label
                    >
                    <div id="modalPrice">
                      <div class="row g-3">
                        <div class="col">
                          <div class="input-group">
                            <div class="input-group-text">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="show_price_type"
                                id="show_price_typeNumber"
                                :value="1"
                                v-model="modalDate.show_price_type"
                              />
                              <span class="ps-2">金額</span>
                            </div>
                            <input
                              type="number"
                              placeholder="請填寫金額ex.2900"
                              class="form-control"
                              v-model="modalDate.price"
                              min="0"
                              :required="modalDate.show_price_type === 1"
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="input-group">
                            <div class="input-group-text">備註文字</div>
                            <input
                              type="text"
                              placeholder="請填寫文字ex.起"
                              class="form-control"
                              v-model="modalDate.price_note"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="input-group mt-3">
                        <div class="input-group-text">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="show_price_type"
                            id="show_price_typeText"
                            :value="2"
                            v-model="modalDate.show_price_type"
                          />
                          <span class="ps-2">文字</span>
                        </div>
                        <input
                          type="text"
                          placeholder="請填寫文字ex.來電洽詢"
                          class="form-control"
                          v-model="modalDate.no_price_note"
                          :required="modalDate.show_price_type === 2"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="modalDestination" class="form-label required"
                      >目的地</label
                    >
                    <input
                      v-model="modalDate.location_to"
                      type="text"
                      class="form-control"
                      id="modalDestination"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalDeparture" class="form-label required"
                      >出發地</label
                    >
                    <input
                      v-model="modalDate.location_from"
                      type="text"
                      class="form-control"
                      id="modalDeparture"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check mb-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="modalDate.show"
                      id="modalShow"
                    />
                    <label class="form-check-label" for="modalShow">
                      上架
                    </label>
                  </div>
                  <div class="mb-3">
                    <h6 class="form-label required">封面圖片</h6>
                    <div class="float-end">
                      <div class="imgBox-has-close">
                        <button
                          v-if="
                            modalDate.image.length && modalDate.image[0].link
                          "
                          @click="removeImage"
                          type="button"
                          class="btn-close"
                          aria-label="Close"
                        />
                        <div class="imgBox ms-2" style="width: 120px">
                          <div class="imgBox-inner">
                            <div class="imgBox-fit">
                              <img
                                v-if="
                                  modalDate.image.length &&
                                  modalDate.image[0].link
                                "
                                :src="modalDate.image[0].link"
                                alt=""
                              />
                              <i v-else class="bi bi-image"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-text mb-3">
                      圖片建議尺寸: <br />
                      1200×800px <br />
                      (圖片格式：JPG、PNG)
                    </div>
                    <div class="mb-3">
                      <label
                        for="formFileCoverImage"
                        class="btn btn-outline-primary"
                        ><i class="bi bi-image"></i> 上傳圖片</label
                      >
                      <input
                        class="form-control d-none"
                        type="file"
                        id="formFileCoverImage"
                        accept="image/png, image/jpeg"
                        @change="onFileChange()"
                        ref="formFileCoverImage"
                      />
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="`modalStatic_uri`" class="form-label required"
                      >自定網址</label
                    >
                    <input
                      v-model="modalDate.static_uri"
                      type="text"
                      class="form-control"
                      id="modalStatic_uri"
                      placeholder="請輸入"
                      pattern="[0-9a-z\-_]+"
                      required
                    />
                    <div class="form-text">
                      只能用英文小寫、數字及'-'、'_'符號(非字首)，不可有空白
                      <br />
                      用於強化 SEO 搜尋
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="websiteKeyword" class="form-label"
                      >關鍵字</label
                    >
                    <div class="form-text mb-3">
                      用 於 SEO Keyword，最多添加 5 項。
                    </div>
                    <div>
                      <button
                        type="button"
                        @click="modalDate.seo_keyword.splice(index, 1)"
                        class="btn btn-primary rounded-pill me-2 mb-2 pe-3"
                        v-for="(keywords, index) in modalDate.seo_keyword"
                        :key="keywords + index"
                      >
                        {{ keywords }} <i class="bi bi-x ps-2"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      @click="showKeywordsModal"
                      v-show="
                        modalDate.seo_keyword &&
                        modalDate.seo_keyword.length < 5
                      "
                      class="btn btn-outline-primary mt-2"
                    >
                      <i class="bi bi-plus"></i> 新增關鍵字...
                    </button>
                  </div>
                  <div class="mb-3">
                    <label for="websiteDescription" class="form-label"
                      >行程簡介</label
                    >
                    <textarea
                      v-model="modalDate.description"
                      class="form-control"
                      id="websiteDescription"
                      rows="5"
                      placeholder="請輸入"
                    ></textarea>
                    <div class="form-text">
                      {{
                        modalDate.description ? modalDate.description.length : 0
                      }}
                      / 160
                    </div>
                    <div class="form-text">
                      用於 SEO Description，建議中文字數控制在 80
                      字以內，英文字數控制在 160 字以內。
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="modalTransportation" class="form-label"
                      >交通工具</label
                    >
                    <input
                      v-model="modalDate.transportation"
                      type="text"
                      class="form-control"
                      id="modalTransportation"
                      placeholder="請輸入"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="modalFlightInfo" class="form-label"
                  >航班資訊列表</label
                >
                <div id="modalFlightInfo">
                  <table
                    v-if="modalDate.flight && modalDate.flight.length"
                    class="table table-bordered align-middle"
                  >
                    <thead>
                      <tr>
                        <th scope="col">航段</th>
                        <th scope="col">
                          出發及中轉機場 / 出發及中轉時間 (當地)
                        </th>
                        <th scope="col">抵達機場 / 抵達時間 (當地)</th>
                        <th scope="col">航空公司 / 航班</th>
                        <th scope="col">刪除</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in modalDate.flight"
                        :key="'flight' + index"
                      >
                        <td>
                          <select class="form-select" v-model="item.type">
                            <option value="outbound">去程</option>
                            <option value="transit">中轉</option>
                            <option value="return">回程</option>
                          </select>
                        </td>
                        <td>
                          <input
                            v-model="item.from"
                            type="text"
                            class="form-control"
                            required
                          />
                        </td>
                        <td>
                          <input
                            v-model="item.to"
                            type="text"
                            class="form-control"
                            required
                          />
                        </td>
                        <td>
                          <input
                            v-model="item.info"
                            type="text"
                            class="form-control"
                            required
                          />
                        </td>
                        <td class="text-center">
                          <button
                            @click="deleteFlightInfo(index)"
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                          ></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    type="button"
                    @click="addFlightInfo"
                    class="btn btn-outline-primary mt-2"
                  >
                    <i class="bi bi-plus"></i> 新增航段
                  </button>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">行程特色</label>
                <quill v-model="modalDate.specification" />
              </div>
              <label class="form-label">行程細節</label>
              <div class="list-group">
                <div
                  class="mb-3"
                  v-for="(item, index) in modalDate.detail"
                  :key="'day' + index"
                >
                  <a
                    data-bs-toggle="collapse"
                    :href="'#multiCollapseExample' + index"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                    class="list-group-item list-group-item-secondary list-group-item-action d-flex justify-content-between align-items-start"
                  >
                    <div>Day {{ index + 1 }}</div>
                    <i class="bi bi-arrow-down-short"></i>
                  </a>
                  <div
                    class="collapse multi-collapse"
                    :id="'multiCollapseExample' + index"
                  >
                    <div class="card card-body">
                      <div class="mb-3">
                        <label for="modalFeature" class="form-label"
                          >行程</label
                        >
                        <quill v-model="item.spec" />
                      </div>
                      <div class="mb-3">
                        <label class="form-label">詳細說明</label>
                        <quill v-model="item.notice" />
                      </div>
                      <div class="mb-3">
                        <label for="modalFood" class="form-label">餐食</label>
                        <textarea
                          v-model="item.food"
                          rows="3"
                          class="form-control"
                          id="modalFood"
                          placeholder="請輸入"
                        ></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="modalTraffic" class="form-label"
                          >交通</label
                        >
                        <textarea
                          v-model="item.traffic"
                          rows="3"
                          class="form-control"
                          id="modalTraffic"
                          placeholder="請輸入"
                        ></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="modalHotel" class="form-label">飯店</label>
                        <textarea
                          v-model="item.hotel"
                          rows="3"
                          class="form-control"
                          id="modalHotel"
                          placeholder="請輸入"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="modalRemark" class="form-label"
                  >注意事項/規定</label
                >
                <quill v-model="modalDate.notice" />
              </div>
              <button ref="submit" type="submit" class="d-none"></button>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              @click="$refs.submit.click()"
              type="button"
              class="btn btn-primary"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <KeywordsModal
      @setKeywords="addKeywords"
      :keywords="modalDate.seo_keyword"
    />
    <DeleteModal
      name="行程"
      :deleteItem="deleteItem"
      @confirmDelete="deleteEvent"
    />
  </div>
</template>

<script>
import { travel } from '@/http/api/travel.js'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import quill from '@/components/plugin/Quill.vue'
import vcalendar from '@/components/plugin/Vcalendar.vue'
import { Modal } from 'bootstrap'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import DeleteModal from '@/components/modal/DeleteModal.vue'
import KeywordsModal from '@/components/modal/KeywordsModal.vue'

const defaultModalDate = {
  serial_no: null,
  show: true,
  name: null,
  start_at: null,
  days: 1,
  show_price_type: 1,
  price: null,
  price_note: null,
  no_price_note: null,
  transportation: null,
  notice: null,
  category_id: null,
  seo_keyword: [],
  static_uri: null,
  image: [],
  location_from: null,
  location_to: null,
  description: null,
  specification: null,
  detail: [
    {
      food: null,
      hotel: null,
      spec: null,
      notice: null
    }
  ],
  flight: null
}

export default {
  name: 'Travel',
  components: {
    quill,
    vcalendar,
    Title,
    Breadcrumb,
    DeleteModal,
    KeywordsModal
  },
  data () {
    return {
      bootstrap_modal: null,
      currentPage: 1,
      deleteItem: '',
      errMsg: null,
      errMsgKey: {
        serial_no: '行程編號',
        name: '行程名稱',
        start_at: '出發日期',
        days: '行程天數',
        price: '金額',
        price_note: '金額備註文字',
        no_price_note: '價格文字',
        transportation: '交通工具',
        notice: '注意事項/規定',
        category_id: '分類',
        seo_keyword: '關鍵字',
        static_uri: '自定網址',
        image: '封面圖片',
        location_from: '出發地',
        location_to: '目的地',
        description: '行程簡介',
        specification: '行程特色',
        detail: '行程細節',
        flight: '航班資訊列表'
      },
      filter: null,
      filterOn: ['serial_no', 'name', 'category', 'days'],
      fields: [
        {
          key: 'serial_no',
          label: '行程編號',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'name',
          label: '行程名稱',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'category',
          label: '分類',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'start_at',
          label: '出發日期',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'days',
          label: '行程天數',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'active',
          label: '功能',
          class: 'align-middle'
        }
      ],
      items: null,
      isEdit: false,
      modalID: null,
      modalDate: JSON.parse(JSON.stringify(defaultModalDate)),
      modalDateCategorySub: null,
      travelCategory: null,
      travelCategorySub: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows',
      'isShowKeywordsModal'
    ]),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    },
    currentPage () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    'modalDate.days': function (data) {
      if (!this.modalDate.detail) {
        this.modalDate.detail = []
      }
      if (Number(data) < this.modalDate.detail.length) {
        this.modalDate.detail.length = Number(data)
      } else {
        for (
          let index = this.modalDate.detail.length;
          index < Number(data);
          index++
        ) {
          this.$set(this.modalDate.detail, index, {
            food: null,
            hotel: null,
            spec: null,
            notice: null
          })
        }
      }
    },
    'modalDate.category_id': function (data) {
      this.modalDateCategorySub = null
      if (data) {
        this.getTravelCategorySub(data)
      } else {
        this.travelCategorySub = null
      }
    },
    isShowKeywordsModal (data) {
      if (!data) this.bootstrap_modal.show()
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetTotalRows',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleDeleteModal',
      'ToggleKeywordsModal'
    ]),
    ...mapActions(['uploadImage']),
    addKeywords (data) {
      const vm = this
      vm.modalDate.seo_keyword = data
    },
    addFlightInfo () {
      const vm = this
      if (!vm.modalDate.flight) {
        vm.modalDate.flight = []
      }
      vm.modalDate.flight.push({
        type: 'outbound',
        from: '',
        to: '',
        info: ''
      })
    },
    createTravel () {
      const vm = this
      travel
        .create(vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '創建資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteEvent () {
      const vm = this
      travel
        .delete(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '刪除資料成功'
            })
            vm.ToggleDeleteModal(false)
            vm.getData()
          } else {
            vm.ToggleDeleteModal(false)
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.ToggleDeleteModal(false)
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteFlightInfo (index) {
      this.modalDate.flight.splice(index, 1)
    },
    getData () {
      const vm = this
      travel
        .get('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    getAnTravel (id) {
      const vm = this
      return new Promise((resolve) => {
        travel
          .get(id, vm.token)
          .then((res) => {
            const { data } = res
            if (res.status <= 201 && data.status === 'success') {
              resolve(data.data)
            } else {
              vm.SetErrMsg(data.errMsg)
              vm.AlertsInfo({
                state: 'error',
                title: '失敗 ' + res.status,
                info: vm.errMsgInfo
              })
              vm.Alerted()
            }
            vm.Loaded()
          })
          .catch((err) => {
            vm.SetErrMsg(err)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗',
              info: vm.errMsgInfo
            })
            vm.Alerted()
            vm.Loaded()
          })
      })
    },
    getTravelCategory () {
      const vm = this
      travel
        .getCategory('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.travelCategory = data.data.filter(
              (category) => category.parent_id === 0
            )
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    getTravelCategorySub (id) {
      const vm = this
      const config = { ...vm.token }
      config.params = {
        parent_id: id
      }
      travel
        .getCategory('', config)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.travelCategorySub = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    initialEvent () {
      const vm = this
      vm.getData()
      vm.getTravelCategory()
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    },
    onFileChange () {
      const vm = this
      vm.uploadImage(vm.$refs.formFileCoverImage)
        .then((value) => {
          if (value) {
            vm.modalDate.image = []
            vm.modalDate.image.push({
              link: value
            })
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    removeImage () {
      this.modalDate.image = []
    },
    async showModal (id) {
      const vm = this
      vm.modalID = id
      vm.bootstrap_modal = new Modal(vm.$refs.travelModal, {
        backdrop: 'static',
        keyboard: false
      })
      if (!id) {
        vm.isEdit = false
        vm.modalDate = JSON.parse(JSON.stringify(defaultModalDate))
        vm.bootstrap_modal.show()
        return
      }
      vm.isEdit = true
      vm.Loading()
      vm.modalDate = await vm.getAnTravel(id)

      if (vm.modalDate.category.parent_id) {
        vm.modalDate.category_id = vm.modalDate.category.parent_id
        setTimeout(() => {
          vm.modalDateCategorySub = vm.modalDate.category.id
        }, 0)
      }
      vm.modalDate.publish_at = new Date(vm.modalDate.publish_at).format(
        'yyyy-MM-ddThh:mm'
      )
      vm.bootstrap_modal.show()
      vm.Loaded()
    },
    showKeywordsModal () {
      const vm = this
      vm.ToggleKeywordsModal(true)
      vm.bootstrap_modal.hide()
    },
    showDeleteModal (id, title) {
      const vm = this
      vm.modalID = id
      vm.deleteItem = title
      vm.ToggleDeleteModal(true)
    },
    save () {
      const vm = this
      if (vm.modalDateCategorySub) {
        vm.modalDate.category_id = vm.modalDateCategorySub
      }
      vm.Loading()
      if (vm.isEdit) {
        vm.updateTravel()
        return
      }
      vm.createTravel()
    },
    async toggleStatus (id) {
      const vm = this
      vm.Loading()
      const travelData = await vm.getAnTravel(id)
      travelData.show = travelData.show ? 0 : 1
      travel
        .update(id, travelData, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '變更顯示狀態成功'
            })
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    updateTravel () {
      const vm = this
      travel
        .update(vm.modalID, vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
      vm.initialEvent()
    }
  }
}
</script>
